import React, {Component} from 'react';
import {render} from 'react-dom';
import {SortableContainer, SortableElement} from 'react-sortable-hoc';
import arrayMove from 'array-move';

const SortableItem = SortableElement(({value}) => <img style={{maxWidth: '25%', margin: '2%'}} src={value}></img>);

const SortableList = SortableContainer(({items}) => {
  return (
    <div>
      {items.map((value, index) => (
        <SortableItem key={`item-${value}`} index={index} value={value} >
          </SortableItem>
      ))}
    </div>
  );
});

class SortableComponent extends Component {
  state = {
    items: this.props.ImageArr
  };
  onSortEnd = ({oldIndex, newIndex}) => {
    this.setState(({items}) => ({
      items: arrayMove(items, oldIndex, newIndex),
    }));
    this.props.reorder(this.state.items)

  };
  render() {
    return <SortableList items={this.state.items} onSortEnd={this.onSortEnd} />;
  }
}

export default SortableComponent


// WEBPACK FOOTER //
// ./src/components/postWrite/REorderImages.jsx